import axios from 'axios'
import JSZip from 'jszip'

export default {
  cancelado: false,
  controller: null,

  async makeZip(arquivos) {
    this.cancelado = false
    const zip = new JSZip()
    let existeArquivos = false
    // eslint-disable-next-line no-restricted-syntax
    for (const arquivo of arquivos) {
      if (this.cancelado) {
        return { mensagem: 'Processo cancelado', status: 'erro' }
      }
      const { url } = arquivo
      this.controller = new AbortController()
      try {
      // eslint-disable-next-line no-await-in-loop
        const response = await axios({
          url,
          method: 'get',
          responseType: 'arraybuffer',
          signal: this.controller.signal,
        })
        if (this.cancelado) {
          return { mensagem: 'Processo cancelado', status: 'erro' }
        }
        existeArquivos = true
        const content = response.data
        const arr = arquivo.caminhoCompleto.split('/')
        const caminho = arquivo.caminhoCompleto.replace(`/${arr[arr.length - 1]}`, '')
        const arquivoBaixado = new Uint8Array(content)
        zip.folder(caminho).file(arquivo.fileName, arquivoBaixado)
        // eslint-disable-next-line no-empty
      } catch (error) {
      }
    }

    if (existeArquivos && !this.cancelado) {
      zip.generateAsync({ type: 'blob' }).then(content => {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(content)
        const fileName = 'DOCUMENTOS EM LOTE'
        link.download = fileName
        document.body.appendChild(link)
        link.style.display = 'none'
        link.click()
        link.remove()
      })
      return { mensagem: 'Download em lote realizado com sucesso!', status: 'sucesso' }
    }
    return { mensagem: 'Processo não realizado, não há documentos para fazer download!', status: 'erro' }
  },

  cancelarBaixaEmDocumentos() {
    this.cancelado = true
    if (this.controller) {
      this.controller.abort()
    }
  },

  downloadCertificado(certificadoArquivo, fileName) {
    const binary = atob(certificadoArquivo)
    const array = []
    for (let i = 0; i < binary.length; i += 1) {
      array.push(binary.charCodeAt(i))
    }
    const file = new Blob([new Uint8Array(array)], { type: 'application/pfx' })

    // inicio do processo de download
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(file)
    link.download = fileName
    document.body.appendChild(link)
    link.style.display = 'none'
    link.click()
    link.remove()
  },
}
